import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* Column 1: Brand */}
        <div className="footer__col footer__col--brand">
          <Link to="/" className="footer__logo">Main2Main</Link>
          <p className="footer__desc">
            La marketplace suisse de seconde main. Achetez et vendez entre particuliers en toute sécurité.
          </p>
          <div className="footer__social">
            <a href="https://www.facebook.com/profile.php?id=61574389498498" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://www.instagram.com/main2main.ch/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
          </div>
        </div>

        {/* Column 2: Categories */}
        <div className="footer__col">
          <h4 className="footer__title">{t('footer.categories', 'Catégories')}</h4>
          <ul className="footer__links">
            <li><Link to="/?category=femme">Femme</Link></li>
            <li><Link to="/?category=homme">Homme</Link></li>
            <li><Link to="/?category=enfant">Enfant</Link></li>
            <li><Link to="/?category=maison">Maison</Link></li>
            <li><Link to="/?category=informatique">Informatique</Link></li>
            <li><Link to="/?category=sport">Sport</Link></li>
          </ul>
        </div>

        {/* Column 3: Help */}
        <div className="footer__col">
          <h4 className="footer__title">{t('footer.help', 'Aide')}</h4>
          <ul className="footer__links">
            <li><Link to="/contact">{t('nav.contact')}</Link></li>
            <li><Link to="/seller/onboarding">{t('footer.sellOnMain2Main', 'Vendre sur Main2Main')}</Link></li>
            <li><Link to="/register">{t('footer.createAccount', 'Créer un compte')}</Link></li>
          </ul>
        </div>

        {/* Column 4: Legal */}
        <div className="footer__col">
          <h4 className="footer__title">{t('footer.legal', 'Légal')}</h4>
          <ul className="footer__links">
            <li><Link to="/cgv">{t('footer.cgv', 'CGV')}</Link></li>
            <li><Link to="/mentions-legales">{t('footer.legalNotice', 'Mentions légales')}</Link></li>
            <li><Link to="/politique-de-confidentialite">{t('footer.privacy', 'Confidentialité')}</Link></li>
          </ul>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="footer__payment">
        <span className="footer__payment-label">{t('footer.securePayment', 'Paiement sécurisé')} :</span>
        <span className="footer__payment-methods">Visa • Mastercard • TWINT • Stripe</span>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Main2Main. {t('footer.allRights', 'Tous droits réservés.')} 🇨🇭 Made in Switzerland</p>
      </div>
    </footer>
  );
};

export default Footer;
